import { DollarSign, Repeat } from 'lucide-react';
import { money } from './dashboardStats';

const Row = ({ label, value, testId }) => (
  <div className="flex items-center justify-between py-2 border-b border-lime-100 last:border-0">
    <span className="text-sm text-stone-600">{label}</span>
    <span className="font-bold text-stone-900" data-testid={testId}>{value}</span>
  </div>
);

export const EarningsCard = ({ earnings }) => (
  <div data-testid="earnings-card" className="bg-white rounded-2xl p-5 shadow-sm border border-lime-100">
    <div className="flex items-center gap-2 mb-3">
      <span className="h-8 w-8 rounded-lg bg-lime-100 flex items-center justify-center">
        <DollarSign className="h-4 w-4 text-green-700" />
      </span>
      <p className="font-semibold text-stone-900" style={{ fontFamily: "'Outfit', sans-serif" }}>Earnings</p>
    </div>
    <Row label="Scheduled this week" value={money(earnings.week)} testId="earnings-week" />
    <Row label="Scheduled this month" value={money(earnings.month)} testId="earnings-month" />
    <div className="mt-3 rounded-xl bg-green-700 text-white p-3 flex items-center justify-between">
      <span className="flex items-center gap-2 text-sm"><Repeat className="h-4 w-4 text-lime-300" />Recurring / month (est.)</span>
      <span className="font-bold text-lg" data-testid="earnings-recurring">{money(earnings.recurringMonthly)}</span>
    </div>
    <p className="text-xs text-stone-400 mt-2">From {earnings.recurringCount} active recurring customers</p>
  </div>
);
